import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { url } from "./api";
import jwtDecode from "jwt-decode";

import { toast } from "react-toastify";
const initialState = {
  token: localStorage.getItem("token"),
  name: "",
  email: "",
  _id: "",
  isAdmin: "",
  loginstatus: "",
  loginerror: "",
  registerstatus: "",
  registererror: "",
  userloaded: false,
};
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async (users, { rejectWithValue }) => {
    try {
      const token = await axios.post(`${url}/register`, { ...users });
      localStorage.setItem("token", token.data);
      return token.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (users, { rejectWithValue }) => {
    try {
      const token = await axios.post(`${url}/signin`, {
        email: users.email,
        password: users.password,
      });
      localStorage.setItem("token", token.data);
      return token.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const Authslice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loaduser(state, action) {
      const token = state.token;

      if (token) {
        const users = jwtDecode(token);
        return {
          ...state,
          ...users,
          userloaded: true,
          isAdmin: users.isAdmin,
        };
      }
    },
    logoutuser(state, action) {
      localStorage.removeItem("token");
      toast.warning(`${state.name} successfully logged out`, {
        position: "bottom-left",
      });
      return {
        ...state,
        name: "",
        token: "",
        email: "",
        _id: "",
        loginstatus: "",
        loginerror: "",
        registerstatus: "",
        registererror: "",
        isAdmin: "",
        userloaded: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(registerUser.pending, (state, action) => {
      return { ...state, registerstatus: "pending" };
    });
    builder.addCase(registerUser.fulfilled, (state, action) => {
      if (action.payload) {
        const userdetails = jwtDecode(action.payload);

        return {
          ...state,
          token: action.payload,
          name: userdetails.name,
          email: userdetails.email,
          _id: userdetails._id,
          registerstatus: "success",
        };
      } else {
        return state;
      }
    });
    builder.addCase(registerUser.rejected, (state, action) => {
      return {
        ...state,
        loginererror: action.payload,
        loginstatus: "rejected",
      };
    });
    builder.addCase(loginUser.pending, (state, action) => {
      return { ...state, loginstatus: "pending" };
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      if (action.payload) {
        const userdetails = jwtDecode(action.payload);

        return {
          ...state,
          token: action.payload,
          name: userdetails.name,
          email: userdetails.email,
          _id: userdetails._id,
          isAdmin: userdetails.isAdmin,
          loginstatus: "success",
        };
      } else {
        return state;
      }
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      return {
        ...state,
        loginerror: action.payload,
        loginstatus: "rejected",
      };
    });
  },
});
export const { loaduser, logoutuser } = Authslice.actions;
export default Authslice.reducer;
